import type { ColumnDef } from '@tanstack/react-table';

import type { GetPermissionGroupsQuery } from 'data/__generated__';
import { numberColumn, textColumn } from 'components/DataTable';

import { PERMISSION_GROUP_APP_LABELS } from './permissionGroupApps';

export type PermissionGroupRow = GetPermissionGroupsQuery['permissionGroups'][number];

export const permissionGroupsColumns: ColumnDef<PermissionGroupRow, unknown>[] = [
    textColumn<PermissionGroupRow, Record<string, unknown>>({
        accessorKey: 'label',
        header: 'Groupe',
        defaultVisible: true,
    }),
    textColumn<PermissionGroupRow, Record<string, unknown>>({
        accessorKey: 'slug',
        header: 'Identifiant',
        defaultVisible: true,
    }),
    textColumn<PermissionGroupRow, Record<string, unknown>>({
        id: 'app',
        accessorFn: (row) => PERMISSION_GROUP_APP_LABELS[row.app],
        header: 'Application',
        defaultVisible: true,
    }),
    numberColumn<PermissionGroupRow, Record<string, unknown>>({
        id: 'permissionsCount',
        accessorFn: (row) => row.permissions.length,
        header: 'Droits',
        defaultVisible: true,
    }),
    textColumn<PermissionGroupRow, Record<string, unknown>>({
        id: 'origin',
        accessorFn: (row) => (row.isEditable ? 'Personnalisé' : 'Géré par le code'),
        header: 'Origine',
        defaultVisible: true,
    }),
];
